import styled from 'styled-components'

export const GroupStyles = styled.div`
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  flex-direction: column;
`
